import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

import { CoffeeProperties } from '@app/api/models';
import { CoffeeProperties as CoffeeProperty } from '@products/interfaces/coffee-properties';

@Component({
  selector: 'app-coffee-properties-subform',
  styleUrls: ['./coffee-properties-subform.component.scss'],
  templateUrl: './coffee-properties-subform.component.html',
})
export class CoffeePropertiesSubformComponent extends SubformBaseComponent {
  DICT_PATH = 'PRODUCTS.COFFEE_PROPERTIES';

  appearanceForm = CoffeeProperty.AppearanceFormEnum;
  caffeineContent = CoffeeProperty.CaffeineContentEnum;
  processingLevel = CoffeeProperty.ProcessingLevelEnum;
  type = CoffeeProperty.TypeEnum;

  static buildForm(fb: FormBuilder, data?: CoffeeProperties) {
    return fb.group({
      type: [data?.type, Validators.required],
      ...(data?.appearanceForm && { appearanceForm: [data?.appearanceForm] }),
      ...(data?.processingLevel && {
        processingLevel: [data?.processingLevel, Validators.required],
      }),
      caffeineContent: [data?.caffeineContent, Validators.required],
    });
  }

  onTypeChange(event: CoffeeProperty.TypeEnum) {
    if (event === 'INSTANT' || event === 'COFFEE_CAPSULE_AND_PILLOW') {
      this.group.addControl(
        'appearanceForm',
        this.fb.control(null, Validators.required)
      );
      this.group.removeControl('processingLevel');
    } else if (event === 'BEANS' || event === 'GROUND') {
      this.group.addControl(
        'processingLevel',
        this.fb.control(null, Validators.required)
      );
      this.group.removeControl('appearanceForm');
    } else {
      this.group.removeControl('appearanceForm');
      this.group.removeControl('processingLevel');
    }
  }
}
